import BaseUrl from "@/BaseUrl";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

interface StyleState {
  styles: any[];
  selectedStyle: any;
  loading: boolean;
  error: string | null;
}

const initialState: StyleState = {
  styles: [],
  selectedStyle: null,
  loading: false,
  error: null,
};

// Use axios directly for async thunk, do not use hooks
export const fetchStylesThunk = createAsyncThunk("styles/fetch", async () => {
  try {
    const response = await axios.get(`${BaseUrl()}/api/style/v1/style`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    // The API returns { data: { results: [...] } }
    const results = response.data?.data?.results;
    return Array.isArray(results) ? results : [];
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch styles");
  }
});

export const styleSlice = createSlice({
  name: "style",
  initialState,
  reducers: {
    fetchStyles: (state) => {
      state.loading = true;
    },
    fetchStylesFulfilled: (state, action: any) => {
      state.styles = action.payload;
      state.loading = false;
    },
    fetchStylesRejected: (state, action: any) => {
      state.loading = false;
      state.error = action.error.message;
    },
    selectStyle: (state, action: any) => {
      state.selectedStyle = action.payload;
    },
    clearSelectedStyle: (state) => {
      state.selectedStyle = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStylesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStylesThunk.fulfilled, (state, action) => {
        state.styles = action.payload;
        state.loading = false;
      })
      .addCase(fetchStylesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message ?? null;
      });
  },
});

export const {} = styleSlice.actions;

export default styleSlice.reducer;

export const fetchStylesGlobal = () => async (dispatch: any) => {
  await dispatch(fetchStylesThunk());
};
